var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('CorePatientsAppBar'),_c('core-patients-drawer'),_c('core-view'),_c('snackbars')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }